module.exports = __webpack_public_path__ + "resources/img/img_rancher4_m.56c418e2be4428b97f4ccee466e1be5a.png";